import { CakeApiBase } from '../CakeApiBase';

export class OnboardingCountriesApi extends CakeApiBase {
  async getWhitelistedCountries() {
    return this.requestManager.get('whitelisted-onboarding-countries');
  }
}
